/**
 * @flow
 * @relayHash 552ec64c811e5e4bb4705725e57e8871
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
type SellerGroupModelList_searchSeller$ref = any;
export type SellerGroupModelListRefetchQueryVariables = {|
  sellerContactId?: ?string,
  sellerModelId?: ?string,
  sellerProductGroupId?: ?number,
  offset?: ?number,
  limit?: ?number,
  sellerModelNumber?: ?string,
  specs?: ?string,
  stocks?: ?string,
  price?: ?string,
  shippingDate?: ?string,
|};
export type SellerGroupModelListRefetchQueryResponse = {|
  +searchSeller: ?{|
    +$fragmentRefs: SellerGroupModelList_searchSeller$ref
  |}
|};
export type SellerGroupModelListRefetchQuery = {|
  variables: SellerGroupModelListRefetchQueryVariables,
  response: SellerGroupModelListRefetchQueryResponse,
|};
*/


/*
query SellerGroupModelListRefetchQuery(
  $sellerContactId: String
  $sellerModelId: String
  $sellerProductGroupId: Int
  $offset: Int
  $limit: Int
  $sellerModelNumber: String
  $specs: String
  $stocks: String
  $price: String
  $shippingDate: String
) {
  searchSeller {
    ...SellerGroupModelList_searchSeller_1cZtnP
  }
}

fragment SellerGroupModelList_searchSeller_1cZtnP on SearchSeller {
  searchSellerGroup(sellerContactId: $sellerContactId, sellerModelId: $sellerModelId, sellerProductGroupId: $sellerProductGroupId, offset: $offset, limit: $limit, sellerModelNumber: $sellerModelNumber, specs: $specs, stocks: $stocks, price: $price, shippingDate: $shippingDate) {
    models {
      sellerProductGroupId
      sellerProductGroupName
      sellerModelId
      sellerContactId
      sellerModelNumber
      price
      stocks
      shippingDate
      salesMethodMaker
      openPrice
      salesMethod
      salesMethodLabel
      specs {
        specId
        specName
        specValue
      }
      groupSpecs {
        specId
        specName
        specValue
      }
      allModelSpecsIsPresentInGroup
    }
    groups {
      sellerProductGroupId
      sellerProductGroupName
      sellerModelId
    }
    pageMetadata {
      totalRecords
      currentPage
      recordsFrom
      recordsTo
      noOfPages
      took
      prevPage
      nextPage
      maxNoOfPageToDisplay
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sellerContactId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sellerModelId",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sellerProductGroupId",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "offset",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "limit",
    "type": "Int",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "sellerModelNumber",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "specs",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "stocks",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "price",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "shippingDate",
    "type": "String",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "limit",
    "variableName": "limit"
  },
  {
    "kind": "Variable",
    "name": "offset",
    "variableName": "offset"
  },
  {
    "kind": "Variable",
    "name": "price",
    "variableName": "price"
  },
  {
    "kind": "Variable",
    "name": "sellerContactId",
    "variableName": "sellerContactId"
  },
  {
    "kind": "Variable",
    "name": "sellerModelId",
    "variableName": "sellerModelId"
  },
  {
    "kind": "Variable",
    "name": "sellerModelNumber",
    "variableName": "sellerModelNumber"
  },
  {
    "kind": "Variable",
    "name": "sellerProductGroupId",
    "variableName": "sellerProductGroupId"
  },
  {
    "kind": "Variable",
    "name": "shippingDate",
    "variableName": "shippingDate"
  },
  {
    "kind": "Variable",
    "name": "specs",
    "variableName": "specs"
  },
  {
    "kind": "Variable",
    "name": "stocks",
    "variableName": "stocks"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerProductGroupId",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerProductGroupName",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "sellerModelId",
  "args": null,
  "storageKey": null
},
v5 = [
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specId",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specName",
    "args": null,
    "storageKey": null
  },
  {
    "kind": "ScalarField",
    "alias": null,
    "name": "specValue",
    "args": null,
    "storageKey": null
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SellerGroupModelListRefetchQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "searchSeller",
        "storageKey": null,
        "args": null,
        "concreteType": "SearchSeller",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "SellerGroupModelList_searchSeller",
            "args": (v1/*: any*/)
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "SellerGroupModelListRefetchQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "searchSeller",
        "storageKey": null,
        "args": null,
        "concreteType": "SearchSeller",
        "plural": false,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "searchSellerGroup",
            "storageKey": null,
            "args": (v1/*: any*/),
            "concreteType": "SellerGroupProduct",
            "plural": false,
            "selections": [
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "models",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerGroupProductModel",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellerContactId",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "sellerModelNumber",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "price",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "stocks",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "shippingDate",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesMethodMaker",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "openPrice",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesMethod",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "salesMethodLabel",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "specs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerGroupProductModelSpec",
                    "plural": true,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "groupSpecs",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "SellerGroupProductModelSpec",
                    "plural": true,
                    "selections": (v5/*: any*/)
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "allModelSpecsIsPresentInGroup",
                    "args": null,
                    "storageKey": null
                  }
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "groups",
                "storageKey": null,
                "args": null,
                "concreteType": "SellerGroupProductModelGroup",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/)
                ]
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "pageMetadata",
                "storageKey": null,
                "args": null,
                "concreteType": "PageMetadata",
                "plural": false,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "totalRecords",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "currentPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "recordsFrom",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "recordsTo",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "noOfPages",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "took",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "prevPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "nextPage",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "maxNoOfPageToDisplay",
                    "args": null,
                    "storageKey": null
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "SellerGroupModelListRefetchQuery",
    "id": null,
    "text": "query SellerGroupModelListRefetchQuery(\n  $sellerContactId: String\n  $sellerModelId: String\n  $sellerProductGroupId: Int\n  $offset: Int\n  $limit: Int\n  $sellerModelNumber: String\n  $specs: String\n  $stocks: String\n  $price: String\n  $shippingDate: String\n) {\n  searchSeller {\n    ...SellerGroupModelList_searchSeller_1cZtnP\n  }\n}\n\nfragment SellerGroupModelList_searchSeller_1cZtnP on SearchSeller {\n  searchSellerGroup(sellerContactId: $sellerContactId, sellerModelId: $sellerModelId, sellerProductGroupId: $sellerProductGroupId, offset: $offset, limit: $limit, sellerModelNumber: $sellerModelNumber, specs: $specs, stocks: $stocks, price: $price, shippingDate: $shippingDate) {\n    models {\n      sellerProductGroupId\n      sellerProductGroupName\n      sellerModelId\n      sellerContactId\n      sellerModelNumber\n      price\n      stocks\n      shippingDate\n      salesMethodMaker\n      openPrice\n      salesMethod\n      salesMethodLabel\n      specs {\n        specId\n        specName\n        specValue\n      }\n      groupSpecs {\n        specId\n        specName\n        specValue\n      }\n      allModelSpecsIsPresentInGroup\n    }\n    groups {\n      sellerProductGroupId\n      sellerProductGroupName\n      sellerModelId\n    }\n    pageMetadata {\n      totalRecords\n      currentPage\n      recordsFrom\n      recordsTo\n      noOfPages\n      took\n      prevPage\n      nextPage\n      maxNoOfPageToDisplay\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'f87ee0f6779cc88b45fea58eade6116c';
module.exports = node;
